module.exports = __webpack_public_path__ + "static/media/chipsCollide1.0e4d9bdc.mp3";